/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

export const Home = {};

$(() => {
    $('.owl-carousel').owlCarousel({
      loop:true,
      margin:30,
      autoplay:true,
      autoplayTimeout:5000,
      autoplayHoverPause:true,
      smartSpeed:1000,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:2
        },
        1000:{
          items:3
        }
      }
    })

    $('.mainCarouselSlidesButton').on('click', function() {
      $('.mainCarouselSlidesButton').removeClass('active');
      $(this).addClass('active');
      $('#mainCarouselSlides').carousel($(this).data('slide'));
    })

    $('.home-periodical-button').on('mouseenter', function() {
      $('.home-periodical-button').removeClass('active');
      $(this).addClass('active');
    })

    $('.home-arrow-prev').on('click', () => {
      $('.home-news').find('.owl-prev').click();
    })

    $('.home-arrow-next').on('click', () => {
      $('.home-news').find('.owl-next').click();
    })

  let archiveDuration = 300;
  let archiveItemsLength = $('.home-periodical-button').length;
  let archiveItemSize = $('.home-periodical-button').outerWidth(true);

  let archiveMenuSize = $('.home-periodical-button-bar').outerWidth();
  $(window).on('resize', function() {
    archiveMenuSize = $('.home-periodical-button-bar').outerWidth();
  });

  let presentObject = 0 ;

  $('.home-periodical-button-next').on('click', function() {
    if (presentObject < archiveItemsLength) {
      presentObject++;
    }
    if (presentObject > 0) {
      $('.home-periodical-button-prev').removeClass('d-none');
    }
    if (presentObject === archiveItemsLength) {
      $('.home-periodical-button-next').addClass('d-none');
    }
    const move = presentObject * archiveItemSize;
    $('.home-periodical-button-inner').animate( { scrollLeft: move}, archiveDuration);
  });

  $('.home-periodical-button-prev').on('click', function() {
    if (presentObject > 0) {
      presentObject--;
    }
    if (presentObject < archiveItemsLength) {
      $('.home-periodical-button-next').removeClass('d-none');
    }
    if (presentObject === 0) {
      $('.home-periodical-button-prev').addClass('d-none');
    }
    const move = presentObject * archiveItemSize;
    $('.home-periodical-button-inner').animate( { scrollLeft: move }, archiveDuration);
  });

});
